import { Stack } from '@mui/material';

import { Text } from 'common';

import { useReactFlowViewContext } from '../../../context/context';

export function ObsoleteBlockFormFields() {
  const { selectedNode } = useReactFlowViewContext();
  return (
    <Stack gap={2}>
      <Text whiteSpace="pre-wrap">{JSON.stringify(selectedNode?.data.config, null, 2)}</Text>
    </Stack>
  );
}
